<template>
  <div>
    <div class="l-bg-white row leads-edit">
      <div class="col-12 col-md-9 col-lg-9 col-xl-9 leads-edit-wrap">
        <template v-if="!lead.ref_id">
          <content-loader />
        </template>
        <template v-else>
          <div class="row bg-grey py-2 header-edit">
            <div class="col-7 col-md-11 col-lg-11 col-xl-11 header-edit-left">
              <div class="row align-items-center header-edit-left-content">
                <button type="button" class="btn btn-back d-block d-xl-none d-md-none d-lg-none" @click="$router.push('/leads')" />
                <div class="col-9 col-md-4 col-lg-4 col-xl-4 flex flex-column flex-lg-row flex-xl-row flex-md-row lead-status">
                  <button type="button" class="btn btn-back d-none d-xl-block d-md-block d-lg-block" @click="$router.push('/leads')" />
                  <div class="d-flex flex-column mr-md-1 mr-lg-1 mr-xl-1">
                    <span class="refId">{{ lead.ref_id }}</span>
                    <div v-if="$_can('leads.source.update') && sources">
                      <simple-select v-model="lead.source_id"
                                     class="small-simple-select"
                                     :options="sources"
                                     :searchable="false"
                                     :hide-select="true"
                                     placeholder="Select Source"
                                     @input="setSource"
                      />
                    </div>
                    <label v-else class="d-none d-md-block d-lg-block d-xl-block header-source ml-0">{{ lead.source.name }}</label>
                  </div>
                  <template v-if="lead.status">
                    <div>
                      <span v-if="lead.status_id === 1"
                            :class="'btn-status btn-active'"
                      >{{ lead.status.name }}</span>
                      <span v-else-if="lead.status_id === 2"
                            :class="'btn-status btn-booked'"
                      >{{ lead.status.name }}</span>
                      <span v-else-if="lead.status_id === 3 || lead.status_id === 6"
                            :class="'btn-status btn-closed'"
                      >{{ lead.status.name }}</span>
                      <span v-else-if="lead.status_id === 4 || lead.status_id === 8"
                            :class="'btn-status btn-ncover'"
                      >{{ lead.status.name }}</span>
                      <span v-else-if="lead.status_id === 5" :class="'btn-status btn-rtbook'">{{ lead.status.name }}</span>
                      <span v-else-if="lead.status_id === 7"
                            :class="'btn-status btn-rejected'"
                      >{{ lead.status.name }}</span>
                      <span v-else
                            :class="'btn-status btn-active'"
                      >{{ lead.status.name }}</span>
                    </div>
                  </template>
                </div>
                <div class="col-1 d-none d-md-block d-lg-block d-xl-block border-right text-right">
                  <label>Booking price:</label>
                  <div class="info-text">$ {{ lead.booked_price }}</div>
                </div>
                <div class="col-1 d-none d-md-block d-lg-block d-xl-block border-right text-center px-1">
                  <label>Min.</label>
                  <div class="info-text">
                    {{ lead.company.minimum_hours ? lead.company.minimum_hours + 'h' : 'Not set' }}
                  </div>
                </div>
                <div class="col-2 d-none d-md-block d-lg-block d-xl-block border-right">
                  <label>Moving Company:</label>
                  <div class="info-text">{{ lead.company.name }}</div>
                </div>
                <div class="col-2 d-none d-md-block d-lg-block d-xl-block border-right" v-if="$_can('leads.assign')">
                  <label>Lead created by:</label>
                  <div class="info-text">{{ lead.created_by && lead.created_by.username }}</div>
                </div>
                <div class="col-2 d-none d-md-block d-lg-block d-xl-block" v-if="$_can('leads.assign')">
                  <label>Assigned:</label>
                  <div class="info-text">{{ lead.cluster_user && lead.cluster_user.username }}</div>
                </div>
              </div>
            </div>
            <div class="col-5 col-md-1 col-lg-1 col-xl-1 pl-md-1 pl-lg-1 pl-xl-1">
              <div class="float-right"
                   v-if="isActive()"
              >
                <div class="dropdown dropdown-menu-right">
                  <button class="btn btn-secondary add-filter"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          v-if="lead.status_id !== 3 || (lead.status_id === 3 && ($_can('leads.status.to_active_from_close') || $_can('leads.no-availability.set')))"
                  />
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                    <button class="dropdown-item" @click="changeStatus(lead.id, 1)"
                            v-if="lead.status_id === 8 || lead.status_id === 10"
                    >
                      Revert to Active
                    </button>
                    <span v-else>
                      <button class="dropdown-item" v-if="lead.status_id === 1 || lead.status_id === 7"
                              @click="changeStatus(lead.id, 5)"
                      >
                        Ready for booking
                      </button>
                      <button class="dropdown-item" @click="showDepositModal = true"
                              v-if="$_can('leads.update') && lead.status_id !== 3"
                      >
                        Change deposit
                      </button>
                      <button class="dropdown-item" @click="changeStatus(lead.id,7)"
                              v-if="lead.status_id !== 7 && lead.status_id !== 3"
                      >
                        On Hold
                      </button>
                      <button class="dropdown-item" @click="changeStatus(lead.id, 10)"
                              v-if="$_can('leads.set-final-follow-up') && lead.status_id !== 10"
                      >
                        Final follow up
                      </button>
                      <button class="dropdown-item" @click="changeStatus(lead.id, 3)"
                              v-if="lead.status_id !== 3"
                      >
                        Close lead
                      </button>
                      <button class="dropdown-item" @click="changeStatus(lead.id, 8)"
                              v-if="$_can('leads.no-availability.set') && lead.status_id !== 8"
                      >
                        No availability
                      </button>
                      <button class="dropdown-item" @click="changeStatus(lead.id, 1)"
                              v-if="$_can('leads.status.to_active_from_close') && lead.status_id === 3"
                      >
                        Back to active
                      </button>
                      <button class="dropdown-item" @click="reassignModal"
                              v-if="$_can('leads.assign') && lead.status_id !== 3"
                      >
                        Reassign lead
                      </button>
                      <button v-if="lead.company.use_mod_booking && hasAvailability && lead.status_id !== 3" class="dropdown-item" @click="showBookingLinkModal = true">
                        Send booking link
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row py-3 mb-3 header-edit">
            <div v-if="lead.status.name !== 'Booked' && !hasAvailability" class="col-md-12 mt-3">
              <div v-if="lead.addresses.length === 2" class="ml-4 alert alert-warning text-center">
                <i class="fa fa-exclamation-triangle mail-warning-icon" /> <span class="acknowledge-msg">Company doesn't have availability on mod24.com</span>
              </div>
              <div v-else class="ml-4 alert alert-warning text-center">
                <i class="fa fa-exclamation-triangle mail-warning-icon" /> <span class="acknowledge-msg">Company availability on mod24.com cannot be checked without both pickup and delivery ZIP</span>
              </div>
            </div>
            <div v-if="lead.customer" class="col-12 col-lg-11 col-xl-11 col-md-11 pr-0 customer-info-wrapper">
              <div class="header-background position-relative flex-column flex-lg-row flex-xl-row flex-md-row">
                <div class="col-12 col-xl-2 col-lg-2 col-md-2 customer-name">
                  <h2 class="pointer"
                      @click="isActive() && (showCustomerModal = !showCustomerModal)"
                  >
                    {{ lead.customer.first_name }}
                    {{ lead.customer.last_name }}
                  </h2>
                </div>
                <div class="col-12 col-md-9 col-lg-9 col-xl-9 d-flex flex-column d-lg-block d-xl-block d-md-block customer-info-content">
                  <small class="mr-4 header-icon">
                    <span class="mod-icon-edit mod-icon-phone" aria-hidden="true" />
                    {{ lead.customer.phone ? phoneMask.maskedPhone(lead.customer.phone) : 'No phone added' }}
                  </small>
                  <small class="mr-4 header-icon">
                    <span class="mod-icon-edit mod-icon-email" aria-hidden="true" />
                    {{ lead.customer.email }}
                    <span v-show="contactEmails()" class="btn-status btn-active">+{{ contactEmails() }}</span>
                  </small>
                  <small v-if="lead.customer.customer_cards && lead.customer.customer_cards.length"
                         class="mr-4 header-icon"
                  >
                    <span class="mod-icon-edit mod-icon-cc" aria-hidden="true" />
                    **** {{ lead.customer.customer_cards.find(c => c.is_default === 1).card_number }}
                  </small>
                  <small v-else class="mr-4 header-icon">
                    <span class="mod-icon-edit mod-icon-cc" />
                    No credit card added
                  </small>
                </div>
                <div class="col-1 header-icon customer-edit text-right">
                  <span class="fa fa-pencil pointer"
                        v-if="isActive()"
                        @click="showCustomerModal = !showCustomerModal"
                  />
                </div>
              </div>
            </div>
            <div v-else class="col-11 col-lg-11 col-xl-11 col-md-11 p-3">
              <div style="background-color: #f8d7d9" class="px-3 py-1">
                <h6>Deleted <br /> Customer</h6>
              </div>
            </div>
            <div class="col-12 col-lg-1 col-md-1 col-xl-1 pl-1">
              <button :disabled="lead.status &&
                        (lead.status.name === 'Booked' || lead.status.name === 'Closed' || lead.status.name === 'No Availability' || lead.status.name === 'Final follow up') &&
                        !lead.customer_note"
                      class="btn btn-secondary pull-right"
                      @click="showModalCustomerNote = !showModalCustomerNote"
              >
                <template v-if="lead.customer_note">View note</template>
                <template v-else>Add note</template>
                <i class="fa text-secondary"
                   aria-hidden="true"
                   :class="showModalCustomerNote ? 'fa fa-caret-up' : 'fa fa-caret-down'"
                />
              </button>
              <customer-note v-if="showModalCustomerNote"
                             :customer-note="customerNote"
                             :model="'leads'"
                             :model-id="lead.id"
                             :note-id="lead.customer_note ? lead.customer_note.id : null"
                             :user-id="user.id"
                             :status-name="lead.status && lead.status.name"
                             @close="showModalCustomerNote = false"
                             @ok="saveCustomerNote"
              />
              <error-field :errors="errors" field="customer" />
            </div>
            <div class="col-12 py-3">
              <HeavyItemsDisclaimer
                :company-heavy-items-fee="lead.company.heavy_items_fee"
                :editable="isActive()"
                :has-heavy-items="lead.has_heavy_items"
                :lead-id="lead.id"
                :model-heavy-items-fee="lead.heavy_items_fee"
                @getLead="getLead"
              />
            </div>
            <div
              v-if="$_can('tags.show')"
              class="col-12 px-5 d-flex align-items-center justify-content-start flex-wrap mb-3 mt-3"
            >
              <tag-color
                v-for="tag in lead.company.tags"
                :key="tag.id"
                :color="tag.color.name"
                :name="tag.name"
                input-class="mr-3"
              />
            </div>

            <booking-link-sent :lead="lead" v-if="lead.booking_link && lead.booking_link.sent_at" />
          </div>

          <div class="row booking-indicator" v-if="lead.status.name === 'Booked'">
            <div class="col-12">
              <div class="row">
                <div class="booking-indicator-wrap">
                  <div class="col-9 d-flex px-0">
                    <span class="fa fa-check" />
                    <h3>The lead has been booked!</h3>
                  </div>
                  <div class="col-3 px-0 text-right" v-if="($_can('jobs.update') || $_can('jobs.view-own'))">
                    <router-link :to="`/jobs/edit/${lead.job_id}`">
                      <p class="d-none d-md-inline-block d-lg-inline-block d-xl-inline-block">Go to job</p>
                      <button type="button" class="btn btn-forward" />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Tabs -->
        <div class="row mb-3">
          <div class="col lead-tabs">
            <div class="mb-4 nav nav-tabs nav-fill">
              <div :class="[overviewModalStep === 1 ? 'active' : '']"
                   class="nav-item nav-link pointer"
                   @click="setOverviewModalStep(1)"
              >
                Addresses
              </div>
              <div :class="[overviewModalStep === 2 ? 'active' : '']"
                   class="nav-item nav-link pointer"
                   @click="goToLocationDetails"
              >
                Location details
              </div>
              <div :class="[overviewModalStep === 3 ? 'active' : '']"
                   class="nav-item nav-link pointer"
                   @click="setOverviewModalStep(3)"
              >
                Rates
              </div>
              <div :class="[overviewModalStep === 5 ? 'active' : '']"
                   class="nav-item nav-link pointer"
                   @click="setOverviewModalStep(5)"
              >
                Discounts & Expenses
              </div>
              <div :class="[overviewModalStep === 6 ? 'active' : '']"
                   class="nav-item nav-link pointer"
                   @click="setOverviewModalStep(6)"
              >
                Fees & Percentages
              </div>
              <div :class="[overviewModalStep === 4 ? 'active' : '']"
                   class="nav-item nav-link pointer"
                   @click="setOverviewModalStep(4)"
                   v-if="$_can('leads.logs.index')"
              >
                Log
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="save"
              @keydown="clearError($event)"
              autocomplete="no"
        >
          <div id="accordion-wrap">
            <div class="mobile-accordion">
              <div
                class="card-header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                @click="setOverviewModalStep(1)"
                ref="addresses"
              >
                <span class="mb-0">
                  Addresses
                </span>
                <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(1)}" />
              </div>
              <div id="collapseOne" class="collapse" :class="{ 'show': overviewModalStep === 1 }" aria-labelledby="headingOne" data-parent="#accordion-wrap">
                <!-- Show addresses -->
                <section>
                  <div class="row mb-4 mt-2 mt-md-0 mt-lg-0 mt-xl-0">
                    <jobs-leads-addresses :data="lead"
                                          :show-dropdown="showDropdown"
                                          :permission="'leads.route.update'"
                                          :errors="errors"
                                          @toggleEditField="toggleEditField"
                                          @setAddress="setAddress"
                                          @switchRoute="switchRoute"
                                          @addAddress="addAddress"
                                          @removeAddress="removeAddress"
                    />
                  </div>
                </section>
              </div>
            </div>

            <div class="mobile-accordion">
              <div
                class="card-header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
                @click="goToLocationDetails"
                ref="location"
              >
                <span class="mb-0">
                  Location details
                </span>
                <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(2) }" />
              </div>

              <div id="collapseTwo" class="collapse" :class="{ 'show': overviewModalStep === 2 }" aria-labelledby="headingTwo" data-parent="#accordion-wrap">
                <!-- Show location details -->
                <section>
                  <div class="row">
                    <div class="map-wrapper col-lg-5 col-xl-6 pr-0">
                      <div v-show="!mapLoading" id="mapid" style="width: 480px; height: 500px" />
                      <div v-if="mapLoading" class="loader-circle" />
                    </div>
                    <div class="distance-wrapper col-lg-7 col-xl-6 mt-4 mt-lg-0 mt-md-0 mt-xl-0">
                      <Distance
                        v-if="lead && lead.distances"
                        :distance="lead.distances"
                      />
                    </div>
                  </div>
                </section>
              </div>

              <div id="collapseFive" class="collapse" :class="{ 'show': overviewModalStep === 5 }" aria-labelledby="headingFive" data-parent="#accordion-wrap">
                <!-- Show location details -->
                <section>
                  <div class="row" v-if="overviewModalStep === 5">
                    <div class="col-6">
                      <LeadDiscounts :lead="lead" />
                    </div>
                    <div class="col-6">
                      <LeadExpenses :lead="lead" />
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div class="mobile-accordion">
              <div
                class="card-header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
                @click="setOverviewModalStep(3)"
                ref="movers"
              >
                <span class="mb-0">
                  Rates
                </span>
                <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(3) }" />
              </div>

              <div id="collapseThree" class="collapse" :class="{ 'show': overviewModalStep === 3 }" aria-labelledby="headingThree" data-parent="#accordion-wrap">
                <!-- Show move info and offers -->
                <section>
                  <div class="row my-3 lead-rates">
                    <div class="col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3">
                      <div class="select-wrap">
                        <label>Move date</label>
                        <flat-pickr v-model="lead.move_date_new"
                                    :config="config"
                                    class="form-control"
                                    style="visibility: hidden"
                                    placeholder="Select date"
                                    red="flatPickr"
                                    @on-close="closedFlatPickr"
                                    data-input
                        />
                        <input v-if="!lead.move_date_new"
                               v-model="lead.move_date"
                               placeholder="Select date"
                               class="form-control flatpickr-input-sec pointer select-date-input"
                               data-toggle
                               :disabled="!isActive()"
                        />
                        <input v-else
                               v-model="lead.move_date_new"
                               placeholder="Select date"
                               class="form-control flatpickr-input-sec pointer select-date-input"
                               data-toggle
                               :disabled="!isActive()"
                        />
                      </div>
                      <error-field :errors="errors" field="move_date" />
                    </div>
                    <div class="col-12 col-lg-4 col-md-4 col-xl-4 px-lg-2 px-md-2 px-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-0">
                      <div class="select-wrap">
                        <label>Arrival window</label>
                        <simple-select v-model="lead.arrival_window_id"
                                       :options="arrival_windows"
                                       label="label"
                                       @input="callGetOffers"
                                       :disabled="!isActive()"
                                       placeholder="Select Arrival Window"
                        />
                      </div>
                      <error-field :errors="errors" field="arrival_window" />
                    </div>
                    <div class="col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-02">
                      <div class="select-wrap">
                        <label>Move size</label>
                        <simple-select v-model="lead.move_size_id"
                                       :options="move_sizes"
                                       @input="callGetOffers"
                                       :disabled="!isActive()"
                                       placeholder="Select Move Sizes"
                        />
                      </div>
                      <error-field :errors="errors" field="move_size_id" />
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2">
                      <div class="select-wrap">
                        <label>Movers</label>
                        <simple-select v-model="lead.movers"
                                       :options="numberOfMovers"
                                       @input="callGetOffers"
                                       :disabled="!isActive()"
                                       placeholder="Number od Movers"
                        />
                      </div>
                      <error-field :errors="errors" field="movers" />
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 col-xl-4 pl-lg-2 pl-0 pl-md-2 pl-xl-2 pr-lg-2 pr-md-2 pr-xl-2">
                      <div class="select-wrap">
                        <label>Trucks</label>
                        <input v-model="lead.trucks"
                               type="text"
                               class="form-control"
                               :disabled="!isActive()"
                               @input="callGetOffers"
                        />
                      </div>
                      <error-field :errors="errors" field="trucks" />
                      <error-field :errors="errors" field="truck_number" />
                    </div>
                    <div class="col-6 col-lg-2 col-md-2 col-xl-2 pr-lg-2 pr-md-2 pr-xl-2 price-info transaction-fee">
                      <label>Transaction fee</label>
                      <p class="m-0">{{ lead.company.charge_fee || 0 }}%</p>
                    </div>
                    <div class="col-6 col-lg-2 col-md-2 col-xl-2 pl-lg-2 pl-0 pl-md-2 pl-xl-2 price-info cash-discount" v-if="lead.company.cash_discount_value > 0">
                      <label>Cash Discount</label>
                      <p class="m-0">{{ lead.cash_discount_value }}{{ lead.cash_discount_unit }} per hour</p>
                    </div>
                  </div>


                  <!--Offers-->
                  <error-field :errors="errors" field="booking" class="my-3" />
                  <template v-if="lead.status_id === 1 || lead.status_id === 5 || lead.status_id === 7">
                    <offer :data="lead"
                           :book-offer-prop="bookOffer"
                           :loading-book-button="loadingBookButton"
                           :button-disabled="buttonDisabled"
                           :booking-phone="lead.company.booking_phone"
                           @set-offer-error="setOfferError"
                           @offers-loaded="setHasAvailability"
                           ref="offerRef"
                           :get-offers-on-load="true"
                    />
                  </template>
                  <template v-else-if="lead.status_id === 6">
                    <div class="alert alert-warning">
                      Booking is currently disabled because the company is not active or setup wasn’t completed. Please
                      contact your manager for further details.
                    </div>
                  </template>
                  <div v-if="lead.company.booking_send_offers">
                    <div v-if="lead.status_id === 1 || lead.status_id === 5 || lead.status_id === 7" class="flex align-items-end justify-content-end mt-2">
                      <div class="flex flex-column align-items-center justify-content-center mb-5">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="sendLeadBookingEmail"
                        >
                          Send offer to customer
                        </button>
                        <div>
                          <customTooltip :config="{ placement: 'top' }">
                            <div
                              slot-scope="{ isOpen, open, close }"
                              @mouseover="open"
                              @mouseleave="close"
                              style="padding: 0 5px 0 5px"
                            >
                              <p v-if="lead.offers_sent_diff" class="lead-sent-offer-diff" data-trigger>
                                Sent {{ lead.offers_sent_diff }}
                              </p>
                              <div
                                v-show="isOpen"
                                data-popper
                                class="custom-tooltip"
                              >
                                <div
                                  v-if="lead.offers_sent"
                                  x-arrow
                                  class="border-black"
                                  style="color: black;"
                                />
                                {{ lead.offers_sent }}
                              </div>
                            </div>
                          </customTooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div class="mobile-accordion">
              <div
                class="card-header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
                @click="setOverviewModalStep(4)"
                ref="log"
              >
                <span class="mb-0">
                  Log
                </span>
                <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(4) }" />
              </div>

              <div id="collapseFour" v-if="overviewModalStep === 4" class="collapse" :class="{ 'show': overviewModalStep === 4 }" aria-labelledby="headingFour" data-parent="#accordion-wrap">
                <!-- Show log -->
                <section>
                  <div class="row mb-3">
                    <div class="col-12">
                      <log v-if="lead.id" :model="lead" type="leads" />
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div class="mobile-accordion">
              <div
                class="card-header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="true"
                aria-controls="collapseSix"
                @click="setOverviewModalStep(6)"
                ref="fees-percentages"
              >
                <span class="mb-0">
                  Fees & Percentages
                </span>
                <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(6) }" />
              </div>

              <div id="collapseSix" v-if="overviewModalStep === 6" class="collapse" :class="{ 'show': overviewModalStep === 6 }" aria-labelledby="headingSix" data-parent="#accordion-wrap">
                <!-- Show fees & percentages -->
                <section>
                  <div class="row mb-3">
                    <div class="col-12">
                      <FeesPercentages
                        :fee-change="lead.fee_change"
                        :lead-id="lead.id"
                        :enabled="isActive()"
                        @getLead="$emit('getLead')"
                      />
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>

          <div class="row mx-0 position-fixed hidden-buttons"
               v-if="editedField"
          >
            <div class="col pb-2 pt-2 text-right">
              <button type="button" @click="discardLead"
                      class="btn btn-secondary ld-ext-right"
                      :class="loadingDiscardButton ? 'running' : ''"
              >
                Discard
                <div class="ld ld-ball ld-flip" />
              </button>
              <button class="btn btn-primary ld-ext-right"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
              >
                Save
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 col-md-3 col-lg-3 col-xl-3 border-left">
        <div class="row">
          <div class="col-12 nav nav-tabs nav-fill p-0">
            <div :class="[rightSidebarTab === 'followups' ? 'active' : '']"
                 class="col-6 nav-item nav-link pointer"
                 @click="rightSidebarTab = 'followups'"
            >
              Follow ups
            </div>
            <div :class="[rightSidebarTab === 'notes' ? 'active' : '']"
                 class="col-6 nav-item nav-link pointer"
                 @click="rightSidebarTab = 'notes'"
            >
              Comments
            </div>
          </div>
        </div>
        <div class="row" style="height: 95vh">
          <div v-if="rightSidebarTab === 'followups'"
               class="w-100 follows-wrap"
          >
            <leads-followups v-if="lead"
                             :lead="lead"
                             class="px-4"
                             @update="getLead"
            />
          </div>
          <div v-if="rightSidebarTab === 'notes'"
               class="col-12"
          >
            <div class="row notes-box pt-3">
              <div class="col-12 single-note pb-4"
                   v-for="note in lead.notes"
                   :key="note.id"
              >
                <div class="border rounded m-0 p-2"
                     v-if="typeof note.note === 'string' && note.note.length > 0"
                >
                  <strong class="d-block">{{ note.user.first_name }} {{ note.user.last_name }}</strong>
                  <p>{{ note.note }}</p>
                  <span class="small">{{ note.date }}</span>
                </div>
              </div>
              <div class="row pt-2 px-2 mb-2 mx-0 fixed-bottom border-top position-absolute notes-field bg-white">
                <div class="col-10 px-0">
                  <div class="border w-100 text-field"
                       v-if="editNote"
                  >
                    <textarea v-auto-resize
                              v-model="lead.note"
                    />
                  </div>
                  <div class="border w-100 text-field"
                       v-else
                  >
                    <textarea v-auto-resize
                              @click="editNote = true"
                    />
                  </div>
                </div>
                <div class="col-2 pointer px-0">
                  <button class="btn btn-primary pt-2"
                          :disabled="editNote === false"
                          @click="saveNote"
                  >
                    <span class="mod-icon-note" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="slide-fade">
      <div class="l-modal-mask"
           v-if="showCustomerModal"
      >
        <side-modal-customer-info v-if="showCustomerModal"
                                  :data="lead"
                                  :lead-id="lead.id"
                                  @cancel="showCustomerModal = false"
                                  @update="getLead"
        />
      </div>
    </transition>

    <!-- reassign modal -->
    <modal v-if="showReassignModal"
           @close="showReassignModal = false"
           :size="'modal-large'"
           :close-strict="true"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10">
            <div>
              <h4>Select user to assign lead to</h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="body">
        <div class="select-wrap">
          <label>Select User</label>
          <simple-select v-model="assigneeId"
                         :options="assignees"
                         @change="clearError($event)"
          />
        </div>
        <error-field :errors="errors" field="cluster_user_id" />
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12">
            <button type="button"
                    class="btn btn-primary pull-right"
                    @click="reassign"
            >
              Reassign
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- send booking link modal -->
    <modal v-if="showBookingLinkModal && bookingLink && lead.company.use_mod_booking"
           @close="showBookingLinkModal = false"
           :size="'modal-large'"
           :close-strict="false"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10">
            <div>
              <h4>Link to be sent</h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="body">
        <div class="input-group">
          <input class="form-control" id="booking-link" type="text" :value="bookingLink" readonly />
          <div class="input-group-append pointer" @click.stop.prevent="copyToClipboard(bookingLink, 'Successfully copied to clipboard')">
            <div class="input-group-text">
              <span>
                <i
                  class="fa fa-copy list-box-icon"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="d-flex align-items-center justify-content-end w-100">
          <button type="button"
                  class="btn btn-primary pull-right mr-3"
                  @click="openSendBookingLink('sms')"
                  :disabled="lead.company.phone_numbers && !lead.company.phone_numbers.find(num => num.type.id === 1)"
          >
            Send link SMS
          </button>
          <button type="button"
                  class="btn btn-primary pull-right"
                  @click="openSendBookingLink('email')"
          >
            Send link email
          </button>
        </div>
      </div>
    </modal>

    <!-- deposit modal -->
    <modal v-if="showDepositModal"
           @close="showDepositModal = false"
           :close-strict="true"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10">
            <div>
              <h4>Enter new deposit value</h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="body">
        <div class="row">
          <div class="col-7">
            <div class="select-wrap">
              <label>Deposit</label>
              <input v-model="lead.deposit_value"
                     type="text"
                     autocomplete="no"
                     class="form-control"
                     placeholder="Enter Deposit"
                     :disabled="!$_can('leads.update')"
              />
            </div>
            <error-field :errors="errors" field="deposit_value" />
          </div>
          <div class="col">
            <div class="select-wrap">
              <label>Unit</label>
              <div class="simple-select">
                <div class="simple-select-header simple-select-header"
                     @click="$_can('leads.update') ? dropdownUnit = !dropdownUnit : null"
                >
                  <input :placeholder="unitOptions.find(el => el.id === lead.deposit_unit).name"
                         class="simple-select-input"
                         @blur="closeList()"
                         :disabled="!$_can('leads.update')"
                  />
                  <span class="simple-select-caret"><i class="fa fa-caret-down" /></span>
                </div>
                <div class="simple-select-options"
                     v-if="dropdownUnit"
                >
                  <ul>
                    <li class="select-option select-option-boolean"
                        @click="setDepositUnit('$')"
                        style="pointer-events: auto;"
                    >
                      <span class="select-label">$</span>
                    </li>
                    <li class="select-option select-option-boolean"
                        @click="setDepositUnit('%')"
                        style="pointer-events: auto;"
                    >
                      <span class="select-label">%</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12">
            <button type="button"
                    class="btn btn-primary pull-right"
                    @click="setDeposit"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- charge modal -->
    <modal v-if="showModalNewTransaction"
           @close="showModalNewTransaction = false"
           @ok="createTransaction"
           :size="'modal-large'"
    >
      <div slot="header">
        <span class="m-header-2">
          New Transaction
        </span>
      </div>
      <div slot="body">
        <div class="row l-m-b-16">
          <div class="col">
            <label class="m-label">Payment type:</label>
            <select class="form-control"
                    v-model="transaction.payment_type_id"
                    name="type"
                    @change="errors.clear('payment_type_id')"
            >
              <option v-for="type in paymentTypes"
                      :value="type.id"
                      :key="type.id"
              >
                {{ type.name }}
              </option>
            </select>
            <error-field :errors="errors" field="payment_type_id" />
          </div>
          <div class="col">
            <label class="m-label">Payment method:</label>
            <select class="form-control"
                    v-model="transaction.payment_method_id"
                    name="payment_type"
                    @change="errors.clear('type_id')"
            >
              <option v-for="method in paymentMethods"
                      :value="method.id"
                      :key="method.id"
              >
                {{ method.name }}
              </option>
            </select>
            <error-field :errors="errors" field="payment_method_id" />
          </div>
          <div class="col">
            <label class="m-label">Price:</label>
            <input type="number"
                   class="form-control"
                   v-model="transaction.amount"
                   min="0"
                   @keydown="errors.clear('amount')"
            />
            <error-field :errors="errors" field="amount" />
          </div>
        </div>

        <payment :customer="lead.customer"
                 :company="lead.company"
                 width="col-12"
                 v-if="transaction.payment_method_id === 4"
                 @update="getLead"
        />

        <div class="row">
          <div class="col">
            <label class="m-label">Notes:</label>
            <textarea rows="5"
                      class="form-control"
                      v-model="transaction.note"
            />
            <error-field :errors="errors" field="note" />
            <error-field :errors="errors" field="ref_id" />
          </div>
        </div>
      </div>
    </modal>

    <booking-link-email-modal
      v-if="showSendBookingLinkEmail"
      :lead="lead"
      @close="showSendBookingLinkEmail = false"
      @load="getLead"
    />
    <booking-link-s-m-s-modal
      v-if="showSendBookingLinkSMS"
      :lead="lead"
      @close="showSendBookingLinkSMS = false"
      @load="getLead"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import toastr from 'toastr';
import mapboxgl from 'mapbox-gl';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import 'flatpickr/dist/flatpickr.css';
import Offer from '../Offer';
import Payment from '../Payment';
import Modal from '../Modal';
import LeadsFollowups from './LeadsFollowups';
import Log from '../ModelLog';
import SideModalCustomerInfo from '../SideModalCustomerInfo';
import PhoneMask from '../../classes/PhoneMask';
import CustomerNote from '../CustomerNote';
import ContentLoader from '../ContentLoader';
import JobsLeadsAddresses from '../JobsLeadsAddresses';
import Distance from '../Distance';
import customTooltip from '../CustomTooltip';
import TagColor from '../settings/Tags/TagColor';
import LeadDiscounts from './LeadDiscounts';
import LeadExpenses from './LeadExpenses';
import BookingLinkSent from './BookingLinkSent';
import BookingLinkEmailModal from './bokingLink/BookingLinkEmailModal';
import BookingLinkSMSModal from './bokingLink/BookingLinkSMSModal';
import HeavyItemsDisclaimer from '../HeavyItemsDisclaimer';
import FeesPercentages from '../FeesPercentages.vue';

export default {
  name: 'LeadsEdit',
  components: {
    FeesPercentages,
    HeavyItemsDisclaimer,
    BookingLinkSMSModal,
    BookingLinkEmailModal,
    BookingLinkSent,
    LeadExpenses,
    LeadDiscounts,
    TagColor,
    Distance,
    JobsLeadsAddresses,
    SideModalCustomerInfo,
    Log,
    ErrorField,
    Offer,
    flatPickr,
    Modal,
    LeadsFollowups,
    Payment,
    CustomerNote,
    ContentLoader,
    customTooltip,
  },
  data: () => ({
    hasAvailability: false,
    lead: {
      addresses: [
        {
          full_address: '',
          street_name: '',
          state: [
            {
              name: '',
            },
          ],
          city: '',
          postal_code: '',
          apartment: '',
        },
      ],
      arrival_window_id: null,
      cluster_user: [],
      company: [],
      customer: [
        {
          contacts: [],
        },
      ],
      move_date: '',
      move_date_new: '',
      move_size: [],
      movers: '',
      notes: [],
      note: '',
      route_id: '',
      source: [],
      status: null,
      trucks: null,
      deposit_value: '',
      minimum_hours: '',
      log: [],
      job_id: '',
    },
    bookingLink: null,
    cSource: undefined,
    arrival_windows: [],
    sources: [],
    address: null,
    addresses: [],
    numberOfMovers: [],
    offers: [],
    showDropdown: [
      {
        0: false,
      },
    ],
    unitOptions: [{ id: '$', name: '$' }, { id: '%', name: '%' }],
    config: {
      dateFormat: 'm/j/Y',
      wrap: true,
      minDate: 'today',
    },
    map: null,
    coordinates: [],
    markers: [],
    path: [],
    expanded: [1],
    mapLoading: false,
    dropdownUnit: false,
    geocodeTimeout: null,
    showCustomerModal: false,
    customerModalStep: 1,
    overviewModalStep: 1,
    showBookingLinkModal: false,
    showReassignModal: false,
    showModalNewTransaction: false,
    showDepositModal: false,
    switchedRoute: false,
    loadingButton: false,
    loadingBookButton: false,
    loadingDiscardButton: false,
    buttonDisabled: false,
    editedField: false,
    transaction: {},
    token: process.env.MAPBOX_TOKEN,
    move_sizes: [],
    rightSidebarTab: 'followups',
    editNote: false,
    showModalCustomerNote: false,
    assigneeId: null,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
    showSendBookingLinkEmail: false,
    showSendBookingLinkSMS: false,
    customerNote: '',
  }),
  computed: {
    ...mapState({
      states: state => state.values.states,
      followups: state => state.followUps.followups,
      paymentMethods: state => state.values.paymentMethods,
      paymentTypes: state => state.values.paymentTypes,
      user: state => state.auth.dispatchUser,
    }),
  },
  watch: {
    lead() {
      if (this.arrival_windows.length < 1) {
        this.getArrivalWindows();
      }
      if (this.sources.length < 1) {
        this.getSources();
      }
      if (this.numberOfMovers.length < 1) {
        this.getNumberOfMovers(this.lead.company_id);
      }
      if (this.move_sizes.length < 1) {
        this.getMoveSizes();
      }
      this.customerNote = this.lead.customer_note ? this.lead.customer_note.note : '';
    },
    $route() {
      this.getPaymentMethods();
      this.getPaymentTypes();
      if (this.$route.query.q) {
        axios.defaults.headers.q = encodeURIComponent(this.$route.query.q);
      }
      axios
        .get(`leads/${this.$route.params.id}`)
        .then(result => {
          this.lead = result.data.data;
          this.getPath(this.lead);
          this.$set(this.lead, 'move_date_new', result.data.data.move_date);
          document.title = `${result.data.data.ref_id} - ${result.data.data.customer.first_name}`;
          if (result.data.data.customer.last_name !== undefined) {
            document.title += ` ${result.data.data.customer.last_name}`;
          }
        })
        .then(() => {
          this.$nextTick(() => {
            this.loadMap();
            window.$('input').attr('autocomplete', 'no');
          });
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    path(newVal) {
      if (newVal.length >= 2 && this.overviewModalStep === 2) {
        this.getDirections();
      }
    },
  },
  created() {
    this.getPaymentMethods();
    this.getPaymentTypes();
    if (this.$route.query.q) {
      axios.defaults.headers.q = encodeURIComponent(this.$route.query.q);
    }
    axios
      .get(`leads/${this.$route.params.id}`)
      .then(result => {
        this.lead = result.data.data;
        this.getPath(this.lead);
        this.$set(this.lead, 'move_date_new', result.data.data.move_date);
        document.title = `${result.data.data.ref_id} - ${result.data.data.customer.first_name}`;
        if (result.data.data.customer.last_name !== undefined) {
          document.title += ` ${result.data.data.customer.last_name}`;
        }
      })
      .then(() => {
        this.$nextTick(() => {
          window.$('input').attr('autocomplete', 'no');
        });
        setTimeout(() => {
          this.getBookingLink();
        }, 3000);
      })
      .catch(err => this.errors.record(err.response.data.error));
  },
  methods: {
    ...mapActions(['getPaymentMethods', 'getPaymentTypes']),
    getPath(lead) {
      lead.addresses.forEach(address => {
        if (address.full_address) {
          const type = address.type_id === 1 ? 'pickup' : 'delivery';
          this.coordinates.push([address.longitude, address.latitude, type]);
          this.path.push([address.longitude, address.latitude]);
        }
      });
    },
    goToLocationDetails() {
      this.setOverviewModalStep(2);
      this.$nextTick(() => {
        if (!this.map || this.switchedRoute) {
          this.loadMap();
        }
        this.getDirections();
      });
    },
    copyToClipboard(text, message) {
      this.$copyText(text).then(() => toastr.success(message, '', { timeOut: 1000 }));
    },
    getBookingLink() {
      axios.post(`leads/${this.$route.params.id}/booking-link`).then(res => {
        this.bookingLink = res.data.data;
      });
    },
    openSendBookingLink(type) {
      this.showBookingLinkModal = false;
      if (type === 'sms') {
        this.showSendBookingLinkSMS = true;
      }

      if (type === 'email') {
        this.showSendBookingLinkEmail = true;
      }
    },
    sendLeadBookingEmail() {
      axios
        .post(`/leads/${this.lead.id}/offers/send`, {})
        .then(() => {
          toastr.success('Successfully sent booking email');
          this.save();
        })
        .catch(() => {
          toastr.error('There was an error when sending your booking email');
        });
    },
    setHasAvailability(availability) {
      this.hasAvailability = availability;
    },
    contactEmails() {
      let count = 0;
      if (this.lead.customer.contacts) {
        this.lead.customer.contacts.forEach(contact => {
          if (contact.email || contact.phone) {
            count += 1;
          }
        });
      }
      return count;
    },
    updateRoute() {
      this.path = [];
      this.coordinates = [];
      this.getPath(this.lead);
    },
    getLead(callback = null) {
      return axios
        .get(`leads/${this.$route.params.id}`)
        .then(result => {
          this.lead = result.data.data;
          this.customerNote = this.lead.customer_note ? this.lead.customer_note.note : '';
          this.editedField = false;
          this.updateRoute();
          if (callback) {
            callback();
          }
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.buttonDisabled = false;
          this.loadingButton = false;
          this.loadingDiscardButton = false;
        });
    },
    discardLead() {
      this.buttonDisabled = true;
      this.loadingDiscardButton = true;
      this.getLead();
    },
    save() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .put(`leads/${this.$route.params.id}`, { ...this.lead })
        .then(res => {
          if (res.data.error) {
            if (res.data.error.postal_code) {
              toastr.warning('Some addresses are not covered by the company', '', { timeOut: 0 });
            }
          } else {
            toastr.success('Successfully updated lead');
            this.editedField = false;
          }
          this.getLead().then(this.callGetOffers);
          if (this.switchedRoute) {
            this.updateRoute();
          }
        })
        .catch(err => {
          if (err.response.data) {
            this.errors.record(err.response.data.error);
          }
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    setSource() {
      if (this.lead.source_id) {
        axios
          .patch(`leads/${this.$route.params.id}/source`, {
            source_id: this.lead.source_id,
          })
          .then(() => {
            toastr.success('Successfully updated source');
            this.getLead();
          })
          .catch(err => {
            if (err.response.data) {
              this.errors.record(err.response.data.error);
            }
          });
      }
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    toggleEditField() {
      this.editedField = true;
      this.switchedRoute = true;
    },
    addAddress(type) {
      this.lead.addresses.push({
        street_name: '',
        state: [
          {
            name: '',
          },
        ],
        state_id: 0,
        city: '',
        postal_code: '',
        apartment: '',
        type_id: type,
        zip: null,
      });
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
        this.toggleEditField();
      });
    },
    removeAddress(index) {
      this.toggleEditField();
      this.errors.clear();
      this.lead.addresses.splice(index, 1);
    },
    getArrivalWindows() {
      axios
        .get(`companies/${this.lead.company.id}/arrival-windows?ref_id=${this.lead.ref_id}`)
        .then(result => {
          result.data.data.forEach(arrivalWindow => {
            arrivalWindow.label = `${arrivalWindow.from}-${arrivalWindow.to}`;
          });
          this.arrival_windows = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getSources() {
      axios
        .get(`values/sources?company_id=${this.lead.company_id}`) // TODO: set sources to vuex if needed
        .then(res => {
          this.sources = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    setAddress(address, index) {
      axios
        .get(
          `geocode?place_id=${encodeURIComponent(address.place_id)}&address=${encodeURIComponent(
            address.full_address,
          )}`,
        )
        .then(res => {
          [address] = res.data.data;
          const addressNew = Object.assign(
            { type_id: this.lead.addresses[index].type_id },
            address,
          );
          this.$set(this.lead.addresses, index, addressNew);
          this.switchedRoute = true;
          this.updateRoute();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
      this.showDropdown[index] = false;
    },
    addAdditionalContact() {
      this.lead.customer.contacts.push({
        email: '',
        phone: '',
      });
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
      });
    },
    removeContact(index) {
      this.lead.customer.contacts.splice(index, 1);
      this.errors.clear();
    },
    getNumberOfMovers(id) {
      axios
        .get(`/companies/${id}/values/movers`)
        .then(res => {
          this.numberOfMovers = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    setOfferError(err) {
      this.errors.record(err.response.data.error);
    },
    bookOffer(lead) {
      const leadId = this.$route.params.id;
      this.loadingBookButton = true;
      this.buttonDisabled = true;
      axios
        .post(`jobs`, lead)
        .then(resJob => {
          this.$nextTick(() => this.getLead());
          axios
            .put(`leads/${leadId}`, lead)
            .then(resLead => {
              this.jobId = resJob.data.data.id;
              if (resLead.data.error) {
                toastr.warning('Some addresses are not covered by the company', '', { timeOut: 0 });
              }
              toastr.success('Successfully booked lead');
              if (resJob.data.data.charges) {
                toastr.success(
                  `Charged $ ${parseFloat(resJob.data.data.charges[0].amount) +
                    parseFloat(resJob.data.data.charges[0].charge_fee)}`,
                );
              }
              this.loadingBookButton = false;
              this.buttonDisabled = false;
            })
            .catch(err => {
              Object.keys(err.response.data.error).forEach(key => {
                toastr.error(err.response.data.error[key], '', { timeOut: 0 });
              });
              this.errors.record(err.response.data.error);
              this.loadingBookButton = false;
              this.buttonDisabled = false;
            });
        })
        .catch(err => {
          Object.keys(err.response.data.error).forEach(key => {
            toastr.error(err.response.data.error[key], '', { timeOut: 0 });
          });
          this.loadingBookButton = false;
          this.buttonDisabled = false;
        });
    },
    callGetOffers() {
      this.toggleEditField();
      if (this.$refs.offerRef) {
        this.$refs.offerRef.clearErrors();
      }
      setTimeout(() => {
        if (this.$refs.offerRef) {
          this.$refs.offerRef.getOffers(this.lead);
        }
      }, 0);
    },
    closedFlatPickr() {
      const vm = this;

      async function f() {
        const promise = new Promise(resolve => {
          vm.$nextTick(() => resolve(vm.$set(vm.lead, 'move_date', vm.lead.move_date_new)));
        });
        if (await promise) {
          vm.callGetOffers();
        }
      }

      f();
    },
    setCustomerModalStep(step) {
      this.customerModalStep = step;
    },
    setOverviewModalStep(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded = [];
        this.expanded.push(value);
        if (value === 1) {
          this.$refs.addresses.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.addresses.scrollIntoView({ behavior: 'smooth' });
          });
        } else if (value === 2) {
          this.$refs.location.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.location.scrollIntoView({ behavior: 'smooth' });
          });
        } else if (value === 3) {
          this.$refs.movers.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.movers.scrollIntoView({ behavior: 'smooth' });
          });
        } else {
          this.$refs.log.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.log.scrollIntoView({ behavior: 'smooth' });
          });
        }
      }
      this.overviewModalStep = value;
    },
    hideCustomerModal() {
      this.showCustomerModal = false;
      this.errors.clear();
      this.customerModalStep = 1;
      this.getLead();
    },
    editCustomer(id) {
      axios
        .put(`customers/${id}`, { ...this.lead.customer, company_id: this.lead.company.id })
        .then(() => {
          toastr.success('Successfully edited customer');
          this.customerModalStep = 1;
          this.showCustomerModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    changeStatus(id, statusId) {
      axios
        .put(`leads/${id}/status`, { status_id: statusId })
        .then(() => {
          toastr.success('Successfully updated status');
          this.getLead();
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassignModal() {
      axios
        .get(`clusters/users/sales`)
        .then(res => {
          res.data.data.forEach(assignee => {
            assignee.name = `${assignee.first_name} ${assignee.last_name}`;
          });
          this.assignees = res.data.data;
        })
        .then(() => {
          this.showReassignModal = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassign() {
      axios
        .patch(`leads/${this.lead.id}/cluster-user`, { cluster_user_id: this.assigneeId })
        .then(() => {
          this.getLead();
          toastr.success('Successfully reassigned lead');
          this.showReassignModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    setDeposit() {
      axios
        .patch(`leads/${this.lead.id}`, {
          deposit_value: this.lead.deposit_value,
          deposit_unit: this.lead.deposit_unit,
        })
        .then(() => {
          this.getLead();
          this.callGetOffers();
          toastr.success('Successfully updated deposit');
          this.showDepositModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    setDepositUnit(unit) {
      this.lead.deposit_unit = unit;
      this.closeList();
    },
    closeList() {
      const vm = this;
      setTimeout(() => {
        vm.dropdown = false;
        vm.dropdownUnit = false;
      }, 100);
    },
    createTransaction() {
      axios
        .post(`charges`, { ...this.transaction, ref_id: this.lead.ref_id })
        .then(res => {
          toastr.success('Successfully charged lead');
          this.showModalNewTransaction = false;
          this.transaction = {};
          this.lead.charges.push(res.data.data);
          this.getLead();
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    loadMap() {
      mapboxgl.accessToken = this.token;
      this.map = new mapboxgl.Map({
        container: 'mapid',
        style: 'mapbox://styles/lannito/ck85qs8tn0eml1ip6srfuvvdc',
        center: [this.lead.addresses[0].longitude, this.lead.addresses[0].latitude],
        minZoom: 2,
        zoom: 12,
      });
      this.switchedRoute = false;
    },
    getDirections() {
      this.mapLoading = true;
      const points = this.path.map(e => e.join(',')).join(';');
      if (points && points.length) {
        axios
          .get(
            `https://api.mapbox.com/directions/v5/mapbox/driving/${points}?&access_token=${
              this.token
            }&geometries=geojson`,
          )
          .then(res => {
            // Set source
            if (!this.map.getSource('directions')) {
              this.map.addSource('directions', {
                type: 'geojson',
                data: {
                  type: 'Feature',
                  geometry: res.data.routes[0].geometry,
                },
              });
            } else {
              // Update source
              this.map.getSource('directions').setData({
                type: 'Feature',
                geometry: res.data.routes[0].geometry,
              });
            }
            // Set layer
            if (!this.map.getLayer('route')) {
              this.map.addLayer({
                id: 'route',
                type: 'line',
                source: 'directions',
                paint: {
                  'line-width': 4,
                  'line-color': '#2962ff',
                  'line-dasharray': [1, 2],
                },
                layout: {
                  'line-cap': 'round',
                },
              });
              this.coordinates.forEach((point, index) => {
                this.map.addLayer({
                  id: `point${index}`,
                  type: 'circle',
                  paint: {
                    'circle-color': '#000',
                  },
                  source: {
                    type: 'geojson',
                    data: {
                      type: 'Feature',
                      geometry: {
                        type: 'Point',
                        coordinates: [point[0], point[1]],
                      },
                    },
                  },
                });
              });

              this.markers.forEach(marker => {
                marker.remove();
              });
              this.coordinates.forEach(point => {
                const el = document.createElement('span');
                if (point[2] === 'delivery') {
                  el.className = 'marker-1';
                } else {
                  el.className = 'marker-0';
                }
                let popupText;
                if (point[2] === 'delivery') {
                  popupText = 'Delivery address';
                } else {
                  popupText = 'Pickup address';
                }
                const popup = new mapboxgl.Popup({
                  className: 'job-in-progress-popup',
                  closeButton: false,
                  closeOnClick: false,
                  anchor: 'bottom',
                  offset: 15,
                })
                  .setLngLat([point[0], point[1]])
                  .setText(popupText)
                  .addTo(this.map);
                this.markers.push(
                  new mapboxgl.Marker(el)
                    .setLngLat([point[0], point[1]])
                    .addTo(this.map)
                    .setPopup(popup),
                );
              });
            }
            const [coordinates] = res.data.routes;

            const bounds = coordinates.geometry.coordinates.reduce((localBounds, coord) => {
              return localBounds.extend(coord);
            }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

            this.map.once('loaded', () => {
              this.map.resize();
            });
            this.map.fitBounds(bounds, {
              padding: 25,
            });
          })
          .finally(() => {
            this.mapLoading = false;
          })
          .catch();
      }
    },
    switchRoute(param, index) {
      this.toggleEditField();
      this.switchedRoute = true;
      const temp = this.lead.addresses[index];
      if (param === 'down') {
        this.$set(this.lead.addresses, index, this.lead.addresses[index + 1]);
        this.$set(this.lead.addresses, index + 1, temp);
        this.updateRoute();
      } else {
        this.$set(this.lead.addresses, index, this.lead.addresses[index - 1]);
        this.$set(this.lead.addresses, index - 1, temp);
        this.updateRoute();
      }
    },
    getMoveSizes() {
      axios
        .get(`companies/${this.lead.company_id}/move-sizes`)
        .then(result => {
          this.move_sizes = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    saveNote() {
      axios
        .post(`leads/${this.$route.params.id}/notes`, {
          note: this.lead.note,
          user_id: this.user.id,
        })
        .then(() => {
          toastr.success('Successfully saved note');
          this.editNote = false;
          this.getLead();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    saveCustomerNote(callback) {
      this.showModalCustomerNote = false;
      this.getLead(callback);
    },
    isActive() {
      return this.lead.status && this.lead.status.name !== 'Booked';
    },
    setFinalFollowUp() {
      this.axios.get(`/leads/${this.lead.id}/final-follow-up`);
      this.getLead();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'JobsEdit') {
      delete axios.defaults.headers.q;
    }
    next();
  },
};
</script>
<style lang="scss">
.input-group > .form-control {
  border: 1px solid #ced4da;
}
.small-simple-select {
  height: auto;
  .simple-select-header {
    height: auto;
    margin: 0;
    padding: 0;

    .simple-select-input {
      height: auto;
      font-size: 11px;
      margin: 0;
      padding: 0;
    }
    .simple-select-caret {
      height: auto;
      top: auto;
      bottom: 0 !important;
      left: 72% !important;
    }
    .simple-select-caret .fa {
      top: auto;
    }
    .simple-select-caret__open {
      height: auto;
      transition: none !important;
      transform: rotate(90deg) !important;
      top: 14px !important;
      padding: 0 12px !important;
    }
  }
  .simple-select-options {
    top: 20px !important;
  }
}
@media screen and (max-width: 1450px) {
  .map-wrapper {
    position: relative;
    height: 500px;
    #mapid {
      width: 480px !important;
      height: 500px !important;
    }
  }
}
@media screen and (max-width: 1280px) {
  .map-wrapper {
    position: relative;
    height: 500px !important;
    #mapid {
      width: 300px !important;
      height: 500px !important;
    }
  }
}
@media screen and (max-width: 991px) {
  .map-wrapper {
    position: relative;
    height: 500px;
    #mapid {
      width: 480px !important;
      height: 500px !important;
    }
  }
}
@media screen and (max-width: 425px) {
  .map-wrapper {
    position: relative;
    height: 500px;
    #mapid {
      width: 300px !important;
      height: 500px !important;
    }
  }
}
.swal2-container {
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/components/leads/LeadsEdit.vue